export const styles = {
  paperItem: {
    width: '100%',
    display: 'flex',
    padding: '0 16px',
    justifyContent: 'space-between',
    columnGap: '20px',
  },
  paperTextContainer: {
    width: 'auto',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    columnGap: '6px',
  },
  greenDotContainer: {
    minWidth: '15px',
    height: '20px',
    display: 'flex',
    borderRadius: '4px',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  greenDot: {
    width: '6px',
    height: '6px',
    display: 'flex',
    backgroundColor: '#379552',
    borderRadius: '50%',
  },
  dateContainer: {
    width: 'auto',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  dateText: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '146%',
    color: '#8C8F9D',
    wordBreak: 'keep-all',
    whiteSpace: 'nowrap',
  },
  badgeContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    rowGap: '20px',
    width: '100%',
    '& .infinite-scroll-component__outerdiv': {
      width: '98%',
      display: 'flex',
      '& .infinite-scroll-component': {
        '&::-webkit-scrollbar': {
          border: 'none',
          width: '11px',
          height: '11px',
          padding: '5px 0',
        },

        '&::-webkit-scrollbar-track': {
          backgroundColor: '#fff',
          border: 'none',
          height: '10px',
        },

        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#D4D6E0',
          width: '2px',
          borderRadius: '6px',
          cursor: 'pointer',
        },
      },
    },
  },
};
